import { CSSProperties, FC, ReactNode } from 'react'

export interface NotificationIcon {
  src: string
  alt: string
  containerStyle?: CSSProperties
  imageStyle?: CSSProperties
}

export interface BaseNotificationProps {
  onClose: () => void
  header?: string
  message: ReactNode
  icon: NotificationIcon
  containerStyle?: CSSProperties
  headerStyle?: CSSProperties
  messageStyle?: CSSProperties
  isHeaderInlineCloseButton?: boolean
  hideCloseButton?: boolean
}

const defaultContainerStyle: CSSProperties = {
  padding: '10px 10px 10px 40px',
  marginTop: '10px',
  textAlign: 'left',
  position: 'relative',
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
}

const defaultCloseButtonStyle: CSSProperties = {
  position: 'absolute',
  right: '10px',
  top: '10px',
  cursor: 'pointer',
  background: 'none',
  border: 'none',
  padding: '0',
  outline: 'none',
  fontSize: '20px',
}

const defaultHeaderStyle: CSSProperties = {
  fontWeight: 'bold',
  marginBottom: '5px',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
}

const defaultMessageStyle: CSSProperties = {
  marginTop: '5px',
}

const BaseNotification: FC<BaseNotificationProps> = ({
  onClose,
  header,
  message,
  icon,
  containerStyle,
  headerStyle,
  messageStyle,
  isHeaderInlineCloseButton = true,
  hideCloseButton = false,
}) => {
  return (
    <div style={{ ...defaultContainerStyle, ...containerStyle }}>
      {icon.containerStyle ? (
        <div style={icon.containerStyle}>
          <img src={icon.src} alt={icon.alt} style={icon.imageStyle} />
        </div>
      ) : (
        <img src={icon.src} alt={icon.alt} style={icon.imageStyle} />
      )}
      {header && (
        <div style={{ ...defaultHeaderStyle, ...headerStyle }}>
          <span>{header}</span>
          {isHeaderInlineCloseButton && !hideCloseButton && (
            <button
              style={defaultCloseButtonStyle}
              onClick={onClose}
              aria-label="Close"
            >
              &times;
            </button>
          )}
        </div>
      )}
      {!isHeaderInlineCloseButton && !hideCloseButton && (
        <button
          style={defaultCloseButtonStyle}
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
      )}
      <span style={{ ...defaultMessageStyle, ...messageStyle }}>{message}</span>
    </div>
  )
}

export default BaseNotification
